import React, { useState } from 'react';

const Phototheque = () => {
  const [showAll, setShowAll] = useState(false);

  const photos = [
    { src: '/images/associate.png', caption: 'Sur le champ de bataille' },
    { src: '/images/recolte_mais.jpg', caption: 'Chargement de la recolte de mais' },
    { src: '/images/photo1.jpg', caption: 'Identification zone de culture' },
    { src: '/images/visite_exploitation.jpg', caption: 'Visite exploitation avec les partenaires' },
    { src: '/images/recolte.jpg', caption: 'Récolte banane plantain' },
    { src: '/images/truie_reproductrice.jpg', caption: 'Truie reproductrice' },
    { src: '/images/production_tomate.jpg', caption: 'Production des tomates' },
    { src: '/images/recolte_courge.jpg', caption: 'Recolte graine de courge' },
    { src: '/images/production_aubergine.jpg', caption: 'Production des aubergines' },
    { src: '/images/exploitation_macabo.jpg', caption: 'Exploitation Macabo' },
    { src: '/images/rejets_banane.jpg', caption: 'Rejets banane Plantain' },
    { src: '/images/corrosol.jpg', caption: 'Corrosol en production' },
    { src: '/images/ananas.jpg', caption: 'Ananas en production' },
  ];

  return (
    <div>
       <section className="hero-section bg-light py-5">
            <div className="container text-center">
                <h1 className="display-4 fw-bold text-white">Explorez notre monde en images</h1>
                <p className="lead text-white">
                Découvrez l'univers de K'MDEU FARMS à travers nos photos. Admirez nos exploitations, 
        nos produits frais et notre engagement pour une agriculture de qualité.
                </p>
            </div>
        </section>
        <br></br>
      <div className="row">
      <h2>Notre monde en image</h2>
        {(showAll ? photos : photos.slice(0, 12)).map((photo, index) => (
          <div key={index} className="col-md-4 mb-4">
           <img src={photo.src} alt={photo.caption} className="img-fluid fixed-size-image" />
            <p>{photo.caption}</p>
          </div>
        ))}
      </div>
      {photos.length > 2 && (
        <button className="btn btn-primary" onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Afficher moins' : 'Afficher plus'}
        </button>
      )}
    </div>
  );
};

export default Phototheque;